import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { navItems, socials } from "./Sidebar";

export const Footer = () => (
  <footer className="bg-slate-900 text-white py-16 px-4 md:px-8" data-testid="footer">
    <div className="max-w-4xl mx-auto space-y-16">
      <div className="space-y-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white">Let's Talk</h2>
        <a
          href="mailto:saidtomehedi@gmail.com"
          className="group inline-flex items-center gap-2 text-xl md:text-2xl font-medium text-white hover:text-primary transition-colors"
          data-testid="footer-email"
        >
          saidtomehedi@gmail.com
          <ArrowUpRight className="h-6 w-6 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="space-y-3">
          <img src="/icon.png" alt="Mehedi Hassain logo" className="w-10 h-10 rounded-xl" data-testid="footer-logo" />
          <h3 className="text-lg font-semibold text-white">Mehedi Hassain</h3>
          <p className="text-slate-400 text-sm">Product Designer · Kolkata, India</p>
        </div>
        <nav className="space-y-3" data-testid="footer-nav">
          {navItems.map((item) =>
            item.download || item.external ? (
              <a
                key={item.name}
                href={item.href}
                target={item.download ? "_blank" : undefined}
                rel="noopener noreferrer"
                className="block text-slate-300 hover:text-white transition-colors"
                data-testid={`footer-${item.testId}`}
              >
                {item.name}
              </a>
            ) : (
              <Link
                key={item.name}
                to={item.href}
                className="block text-slate-300 hover:text-white transition-colors"
                data-testid={`footer-${item.testId}`}
              >
                {item.name}
              </Link>
            )
          )}
        </nav>
        <div className="space-y-3" data-testid="footer-socials">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-slate-300 hover:text-white transition-colors"
              data-testid={`footer-social-${s.name.toLowerCase().replace(/ /g, "-")}`}
            >
              {s.name}
            </a>
          ))}
        </div>
      </div>

      <div className="pt-8 border-t border-slate-800 text-slate-400 text-sm text-center">
        <p>© 2026 Mehedi Hassain. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
